import axios from 'axios';
import { Toast } from 'antd-mobile';
import utils from 'utils';

const pending = {};
const responseCheck = (url) => {
  // api域名为后端新框架，统一了接口返回逻辑，如果code不为 0 则返回错误信息
  try {
    return !!url && url?.split('/')[2].split('.')[0] === 'api';
  } catch (error) {
    return false;
  }
};

axios.interceptors.request.use(
  config => {
    let t;
    t = setTimeout(() => {
      Toast.loading('加载中...');
    }, 500);
    pending[t] = 1;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  response => {
    Toast.hide();
    return response;
  },
  err => {
    Toast.hide();
    return axiosRetry(err);
  }
);

// axios response 错误拦截器
const interceptorsResponseErr = err => {
  Toast.hide();
  if (err?.response?.status) {
    switch (err.response.status) {
      case 400:
        return err.response;
      default:
        break;
    }
  }
  return Promise.reject(err);
};

// 清除setTimeout
const clearAllTimeouts = () => {
  for (const t in pending) {
    if (pending.hasOwnProperty(t)) {
      clearTimeout(t);
      delete pending[t];
    }
  }
};

// axios 失败重试
const axiosRetry = err => {
  const { config, response } = err;

  // retry配置开启检测
  if (!config || !config.retry) {
    return interceptorsResponseErr(err);
  }

  // http code 范围检测
  if (response && response.status) {
    let isInRange = false;
    const retryStatusCodes = config.retryStatusCodes;
    for (const [min, max] of retryStatusCodes) {
      const status = response.status;
      if (status >= min && status <= max) {
        isInRange = true;
        break;
      }
    }
    if (!isInRange) {
      return interceptorsResponseErr(err);
    }
  }

  config.__retryCount = config.__retryCount || 0;

  // retry次数检测
  if (config.__retryCount >= config.retry) {
    return interceptorsResponseErr(err);
  }

  config.__retryCount += 1;

  const backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, config.retryDelay || 1);
  });

  return backoff.then(function() {
    return axiosRequest(config);
  });
};

// 正确处理
const successState = () => { };

// 错误处理
const errorState = err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        Toast.fail('无效的token');
        break;
      case 404:
        Toast.offline('报告，找不到资源');
        break;
      case 500:
        Toast.offline('哎呦，服务器出故障了≧﹏≦');
        break;
      default:
        Toast.offline('哎呦，服务器出故障了≧﹏≦');
    }
  } else {
    Toast.offline('哎呦，服务器出故障了≧﹏≦');
  }
};

// axios request主函数
const axiosRequest = opts => {
  return axios(opts)
    .then(res => {
      const { data, status } = res;
      clearAllTimeouts();
      if (responseCheck(res.config.baseURL) && data?.code !== 0) {
        return Promise.reject({
          ...data,
          close,
          status
        });
      }
      if ((data && (data.success === false || data.status === false))) {
        Toast.info(data.msg || data.message);
        throw new Error('notReport');
      } else if (data) {
        successState(data);
        return res;
      } else {
        throw new Error('notReport');
      }
    })
    .catch(err => {
      clearAllTimeouts();
      if (err.message !== 'notReport') {
        return Promise.reject(err);
      } else {
        errorState(err);
      }
      throw new Error('httpServerError');
    });
};

const httpServer = (opts, data, baseURL, token, headers) => {
  const queryParmas = utils.getQueryString() || {};

  const Public = {
    // 公共参数
  };

  const httpDefaultOpts = {
    // http默认配置
    method: opts.method,
    baseURL: baseURL,
    url: opts.url,
    timeout: 1000 * 60 * 10,
    params: { ...Public, ...data },
    data: { ...Public, ...data },
    headers: {
      token: token,

      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',

      // 添加 设备信息
      'App-Device': queryParmas.app_device || '',
      'App-Version': queryParmas.app_version || '',
      'App-Key': queryParmas.app_key || '',
      'Os-Version': queryParmas.os_version || ''
    },
    retry: 3,
    retryStatusCodes: [
      [100, 199],
      [429, 429],
      [500, 599]
    ],
    retryDelay: 500
  };

  if (opts.method === 'get') {
    delete httpDefaultOpts.data;
  } else {
    delete httpDefaultOpts.params;
  }

  if (headers) {
    httpDefaultOpts.headers = headers;
  }

  return axiosRequest(httpDefaultOpts);
};

export default httpServer;
